import Service from 'vuex-service-api'


const service =   new Service({
  baseURL: window.process.env.API_HOST_GLOBAL,
  tocken: process.env.API_TOKEN
});


export default service;



// WEBPACK FOOTER //
// ./src/service.js